import ManualBookShiftPage from './ManualBookShiftPage';
export default ManualBookShiftPage;